import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function AuthRoute() {
  const token = useSelector((state) => state?.user?.token);
  const user = useSelector((state) => state?.user);
  const location = useLocation();

  // Allow certain routes to bypass redirection
  const allowedRoutes = ["/draft", "/some-other-path"]; // Add specific paths you want to bypass
  const isAllowedRoute = allowedRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  if (!token) {
    return <Outlet />; // User is not authenticated, allow access to child routes
  }

  if (isAllowedRoute) {
    return <Outlet />; // Allow access to non-dashboard routes like /draft/:draftId
  }

  // Redirect authenticated users to their respective dashboards
  return user?.user_type === "clinic" ? (
    <Navigate to="/clinic-dashboard" />
  ) : user?.user_type === "organization" ? (
    <Navigate to="/organization-dashboard" />
  ) : user?.user_type === "mro" ? (
    <Navigate to="/phyic-dashboard" />
  ) : user?.user_type === "patient" ? (
    <Navigate to="/patient-dashboard" />
  ) : user?.user_type === "collectionsite" ? (
    <Navigate to="/site-dashboard" />
  ) : user?.user_type === "collector" ? (
    <Navigate to="/collector-dashboard" />
  ) : user?.user_type === "technician" ? (
    <Navigate to="/technician-dashboard" />
  ) : user?.user_type === "scientist" ? (
    <Navigate to="/scientist-dashboard" />
  ) : (
    <Navigate to="/dashboard" />
  );
}
